/**
 *
 * @component   房屋验收报告pdf  TAB
 *
 **/

import React, { memo } from 'react';
import { Button } from 'antd';
import moment from 'moment';
import BaseListWrap from '&/components/BaseListWrap';
import LogoImage from '@/assets/img/logo.png';
import { queryProjectAudit } from '@/api/personCenter/projectSpace1.4';
import printJS from 'print-js';
import './ProjectCheckReport.scss';

function ProjectCheckReport(props) {
    useEffect(() => {
        queryAudit();
    }, []);

    const { projectId } = props;
    const [result, setResult] = useState({
        project: { designer: [], manager: [] },
        plan: [],
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isEmpty, setisEmpty] = useState(false);

    function queryAudit() {
        setIsLoading(true);
        queryProjectAudit({
            projectId,
        })
            .then(({ data }) => {
                data.plan = data.plan.map((el, idx) => ({
                    ...el,
                    num: idx + 1,
                }));
                setResult(data);
                setisEmpty(true);
            })
            .catch(() => {
                setisEmpty(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const pdm = useRef();
    const onPrint = () => {
        printJS({
            printable: pdm.current,
            type: 'html',
            targetStyles: ['*'],
            font_size: '',
            maxWidth: null,
            style: `@page {
                margin-bottom: 0mm;
                margin-top: 0mm;
              }
              * {
                height: auto!important;
              }
              body {
                display: flex;
                justify-content: center;
              }
              table {
                border-top: 0.1rem solid !important;
              }
              tr {
                border-right: 0.1rem solid !important;
              }
              th, td {
                border-left: 0.1rem solid !important;
                border-bottom: 0.1rem solid !important;
              }
              tr td:last-child,th:last-child {
                border-right: 0.1rem solid !important;
              }
              table {
                border-collapse: unset!important;
              }
              `,
        });
    };

    const isFirefox = () => {
        return typeof InstallTrigger !== 'undefined';
    };

    const satisficings = intl.get('projectSpace.satisficings').split('/');

    return (
        <BaseListWrap isLoading={isLoading} isEmpty={isEmpty}>
            <div className="button-container">
                <Button onClick={onPrint}>
                    {intl.get('userCenter.print')}
                </Button>
            </div>

            <div
                id="print-el"
                ref={pdm}
                className={`project-check-report ${
                    isFirefox() ? 'is--firefox' : ''
                }`}>
                <div>
                    <header className="report-header">
                        <img className="logo" src={LogoImage} />
                        <div className="title-text">
                            {intl.get('projectSpace.houseCheck')}
                        </div>
                    </header>
                    <div className="report-table">
                        <table cellSpacing="0">
                            <tbody>
                                <tr className="report-table-row">
                                    <td className="td1 text-center">
                                        <div>
                                            {intl.get('projectSpace.checkName')}
                                        </div>
                                    </td>
                                    <td className="td2">
                                        <div>{result.project.projectName}</div>
                                    </td>
                                    <td className="td3 text-center">
                                        <div>
                                            {intl.get('projectSpace.generTime')}
                                        </div>
                                    </td>
                                    <td className="td4">
                                        <div>
                                            {moment
                                                .unix(result.project.checkDate)
                                                .format('YYYY-MM-DD HH:ss')}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-center">
                                        <div>
                                            {intl.get('projectSpace.address')}
                                        </div>
                                    </td>
                                    <td colSpan="3">
                                        <div>{result.project.address}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="col">
                                        <div>{intl.get('base.serialNum')}</div>
                                    </th>
                                    <th scope="col">
                                        <div>
                                            {intl.get('projectSpace.checkItem')}
                                        </div>
                                    </th>
                                    <th scope="col">
                                        <div>
                                            {intl.get(
                                                'projectSpace.checkResult'
                                            )}
                                        </div>
                                    </th>
                                    <th scope="col">
                                        <div>{intl.get('base.remark')}</div>
                                    </th>
                                </tr>
                                {result.plan.map(el => (
                                    <tr key={el.id}>
                                        <td>
                                            <div className="text-center">
                                                {el.num}
                                            </div>
                                        </td>
                                        <td>
                                            <div>{el.planName}</div>
                                        </td>
                                        <td>
                                            <div className="text-center">
                                                {
                                                    [
                                                        intl.get(
                                                            'base.disqualification'
                                                        ),
                                                        intl.get(
                                                            'base.qualified'
                                                        ),
                                                    ][el.status]
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                className={`show-space ${
                                                    el.remark
                                                        ? ''
                                                        : 'text-center'
                                                }`}>
                                                {el.remark || '-'}
                                            </div>
                                        </td>
                                    </tr>
                                ))}

                                <tr>
                                    <td>
                                        <div className="text-center">
                                            {intl.get(
                                                'projectSpace.designSatisfaction'
                                            )}
                                        </div>
                                    </td>
                                    <td colSpan="3">
                                        <div>
                                            {
                                                satisficings[
                                                    result.project.drawingScore
                                                ]
                                            }
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-center">
                                            {intl.get(
                                                'projectSpace.constructionSatisfaction'
                                            )}
                                        </div>
                                    </td>
                                    <td colSpan="3">
                                        <div>
                                            {
                                                satisficings[
                                                    result.project.planScore
                                                ]
                                            }
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="4" className="table-footer">
                                        <div className="row-container">
                                            <div>
                                                {intl.get(
                                                    'baseComponents.baseInfo.projectManager'
                                                )}
                                                <p className="footer-signature">
                                                    {result.project.manager.join(
                                                        '，'
                                                    )}
                                                </p>
                                            </div>
                                            <div>
                                                {intl.get(
                                                    'baseComponents.baseInfo.designer'
                                                )}
                                                <p className="footer-signature">
                                                    {result.project.designer.join(
                                                        '，'
                                                    )}
                                                </p>
                                            </div>
                                            <div>
                                                {intl.get(
                                                    'projectSpace.ownerSignature'
                                                )}
                                                <p className="footer-signature">
                                                    <img
                                                        className="signature-image"
                                                        src={
                                                            result.project
                                                                .signaturePath
                                                        }
                                                        alt=""
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </BaseListWrap>
    );
}

export default memo(ProjectCheckReport);
